module.exports = __webpack_public_path__ + "static/img/tl_4@2x.90e2565b.png";